// Tracking App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import Bikhra from './components/Bikhra.jsx';
import BooksPage from './components/BooksPage.jsx';
import LandingPage from './components/LandingPage.jsx';
import ComicViewer from './components/ComicViewer.jsx';
import EmpireAndFreedomV2 from './components/EmpireAndFreedomV2.jsx';

// Wrapper to enable View Transitions
function AppRoutes() {
  return (
    <Routes>
      {/* New home page */}
      <Route path="/" element={<Bikhra />} />
      
      {/* Books listing page */}
      <Route path="/books" element={<BooksPage />} />
      
      {/* Empire & Freedom V2 */}
      <Route path="/books/empire-freedom" element={<EmpireAndFreedomV2 />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

// Book page component that handles the landing page and viewer
function BookPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const readParam = searchParams.get('read');
  const pageParam = searchParams.get('page');
  
  const viewerOpen = readParam === 'true';
  const startPage = pageParam ? parseInt(pageParam) : 1;

  const openViewer = (page = 1) => {
    // Push new history state with read=true
    navigate(`?read=true&page=${page}`, { replace: false });
  };

  const closeViewer = () => {
    // Go back in history instead of just closing
    navigate(-1);
  };

  return (
    <>
      {!viewerOpen && <LandingPage onReadNow={() => openViewer(1)} />}
      {viewerOpen && <ComicViewer startPage={startPage} onClose={closeViewer} />}
    </>
  );
}

export default App;
